define('webshopLandingpagesDetailBodyLandingpageView',[
  'module',
  'headerFooterView',
  'webshopLandingpagesDetailBodyLandingpageBodyView',
  'webshopLandingpagesDetailBodyLandingpageFooterView'
], function (
  Module,
  HeaderFooterView,
  BodyView,
  FooterView
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    childView: BodyView,
    childFooterView: FooterView
  });
});
